import { render, staticRenderFns } from "./QuestionFloSerial.vue?vue&type=template&id=31c5f59e&scoped=true&"
import script from "./QuestionFloSerial.vue?vue&type=script&lang=js&"
export * from "./QuestionFloSerial.vue?vue&type=script&lang=js&"
import style0 from "./QuestionFloSerial.vue?vue&type=style&index=0&id=31c5f59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c5f59e",
  null
  
)

export default component.exports